import { jsxs as H, jsx as l } from "react/jsx-runtime";
import { useState as I, useRef as y, useEffect as O } from "react";
import b from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as R } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { u as _, C as B } from "./useChartOptions-336145ca.mjs";
const N = b.div`
  height: ${(e) => e.theme.components.columnChart.Wrapper.height};
  width: ${(e) => e.theme.components.columnChart.Wrapper.width};
  position: ${(e) => e.theme.components.columnChart.Wrapper.position};
  #axisEle {
    height: ${(e) => e.theme.components.columnChart.Wrapper.axisEle.height};
    overflow: ${(e) => e.theme.components.columnChart.Wrapper.axisEle.overflow};
    position: ${(e) => e.theme.components.columnChart.Wrapper.axisEle.position};
    top: ${(e) => e.theme.components.columnChart.Wrapper.axisEle.top};
    background: ${(e) => e.theme.components.columnChart.Wrapper.axisEle.background};
    .apexcharts-legend.apexcharts-align-left {
      visibility: ${(e) => e.theme.components.columnChart.Wrapper.axisEle.apexChartsLegendAlignLeft.visibility};
    }
  }
`, Q = b.div`
  height: ${(e) => e.theme.components.columnChart.MainWrapper.height};
  width: ${(e) => e.theme.components.columnChart.MainWrapper.width};
  overflow-x: ${(e) => e.theme.components.columnChart.MainWrapper.overflowX};
  position: ${(e) => e.theme.components.columnChart.MainWrapper.position};

  .apexcharts-yaxistooltip {
    padding: ${(e) => e.theme.components.columnChart.MainWrapper.apexchartsYaxisTooltip.padding} !important;
  }
  .apexcharts-legend.apx-legend-position-top,
  .apexcharts-legend.apx-legend-position-bottom {
    max-height: ${(e) => e.theme.components.columnChart.MainWrapper.apexchartsLegendPositionBottom.maxHeight} !important;
  }

  .apexcharts-legend .apexcharts-legend-series {
    display: ${(e) => e.theme.components.columnChart.MainWrapper.apexchartsLegendSeries.display} !important;
    align-items: ${(e) => e.theme.components.columnChart.MainWrapper.apexchartsLegendSeries.alignItems} !important;
    padding: ${(e) => e.theme.components.columnChart.MainWrapper.apexchartsLegendSeries.padding};
    gap: ${(e) => e.theme.components.columnChart.MainWrapper.apexchartsLegendSeries.gap};

    .apexcharts-legend-text {
      padding-left: ${(e) => e.theme.components.columnChart.MainWrapper.apexchartsLegendSeries.apexchartsLegendText.paddingLeft};
      margin-left: ${(e) => e.theme.components.columnChart.MainWrapper.apexchartsLegendSeries.apexchartsLegendText.marginLeft};
    }
  }

  ${({ $vertical: e, ...t }) => {
  if (e)
    return `
      .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series {
        display: ${t.theme.components.columnChart.MainWrapper.vertical.apexchartsLegendAlignLeftLegendSeries.display};
        align-items: ${t.theme.components.columnChart.MainWrapper.vertical.apexchartsLegendAlignLeftLegendSeries.alignItems};
        padding: ${t.theme.components.columnChart.MainWrapper.vertical.apexchartsLegendAlignLeftLegendSeries.padding};
        padding-left: ${t.theme.components.columnChart.MainWrapper.vertical.apexchartsLegendAlignLeftLegendSeries.paddingLeft};
        margin: ${t.theme.components.columnChart.MainWrapper.vertical.apexchartsLegendAlignLeftLegendSeries.margin} !important;
        width: ${t.theme.components.columnChart.MainWrapper.vertical.apexchartsLegendAlignLeftLegendSeries.width};
      }
      .legend-item {
        width: ${t.theme.components.columnChart.MainWrapper.vertical.legendItem.width};
      }
      .apexcharts-legend-text {
        pointer-events: ${t.theme.components.columnChart.MainWrapper.vertical.apexchartsLegendText.pointerEvents};
        display: ${t.theme.components.columnChart.MainWrapper.vertical.apexchartsLegendText.display} !important;
        /* gap: 10px; */
        justify-content: ${t.theme.components.columnChart.MainWrapper.vertical.apexchartsLegendText.justifyContent} !important;
        margin-left: ${t.theme.components.columnChart.MainWrapper.vertical.apexchartsLegendText.marginLeft} !important;
      }
      .apexcharts-legend-text {
        width: ${t.theme.components.columnChart.MainWrapper.vertical.apexchartsLegendText.width} !important;
        line-height: ${t.theme.components.columnChart.MainWrapper.vertical.apexchartsLegendText.lineHeight};
      }
      .apexcharts-legend-marker {
        top: ${t.theme.components.columnChart.MainWrapper.vertical.apexchartsLegendMarker.top} !important;
      }
      .total-label {
        position:${t.theme.components.columnChart.MainWrapper.vertical.totalLabel.position};
        font-weight: ${t.theme.components.columnChart.MainWrapper.vertical.totalLabel.fontWeight};
        left: ${t.theme.components.columnChart.MainWrapper.vertical.totalLabel.left};
        margin: ${t.theme.components.columnChart.MainWrapper.vertical.totalLabel.margin} !important;
        padding-top: ${t.theme.components.columnChart.MainWrapper.vertical.totalLabel.paddingTop};
        width: ${t.theme.components.columnChart.MainWrapper.vertical.totalLabel.width};
      }
      .total-text {
        margin-left: ${t.theme.components.columnChart.MainWrapper.vertical.totalText.marginLeft} !important;
      }
    `;
}}
`, V = ({
  chartLibElement: e,
  legend: t,
  isCategorical: w = !0,
  colorPallete: S = ["blue"],
  hideLabel: T = !1,
  labelFormatter: A,
  series: o,
  xAxis: E,
  yAxis: j,
  variant: d = "default",
  gridType: k = "yaxis",
  height: i = 350,
  width: r,
  isScroll: g = !0
}) => {
  const q = R({ label: "Column Chart" }), P = "light", [p, C] = I(0), a = y(null), n = y(null), { options: W } = _({
    legend: t,
    isCategorical: w,
    colorPallete: S,
    hideLabel: T,
    labelFormatter: A,
    xAxis: E,
    yAxis: j,
    type: B.COLUMN,
    variant: d,
    gridType: k,
    series: o,
    mode: P
  }), c = o;
  return O(() => {
    setTimeout(() => {
      var L, M;
      if (g && (a != null && a.current) && (n != null && n.current)) {
        a == null || a.current.querySelector('div[type="bar"]');
        const u = n == null ? void 0 : n.current, x = a == null ? void 0 : a.current.querySelector("g.apexcharts-yaxis"), m = a == null ? void 0 : a.current.querySelector(".apexcharts-legend.apexcharts-align-left"), h = (x == null ? void 0 : x.getBoundingClientRect().width) || 50;
        if (h > 50 && ((t == null ? void 0 : t.position) === "bottom" || (t == null ? void 0 : t.position) === "top") && (m == null || m.setAttribute("style", `${m.getAttribute("style")}; inset: auto 0px -5px ${h - 18}px`)), u == null || u.setAttribute("style", `height: unset; width: ${h + 5}px`), !r) {
          let $ = 1;
          o.forEach((s) => {
            var v;
            ((v = s == null ? void 0 : s.data) == null ? void 0 : v.length) > $ && ($ = s.data.length);
          });
          const f = $ * 50 + h || 0;
          ((L = a == null ? void 0 : a.current) == null ? void 0 : L.clientWidth) > f ? C((M = a == null ? void 0 : a.current) == null ? void 0 : M.clientWidth) : C(f);
        }
      }
    }, 500);
  }, [g, o, r]), /* @__PURE__ */ H(N, { ...q, children: [
    /* @__PURE__ */ l(
      Q,
      {
        $vertical: (t == null ? void 0 : t.orientation) === "vertical",
        ref: a,
        children: /* @__PURE__ */ l(
          e,
          {
            width: r ? `${r}px` : p || "100%",
            height: i ? `${i}px` : "350px",
            options: W,
            series: c,
            type: "bar"
          },
          `${d}_${c.length}`
        )
      }
    ),
    g && /* @__PURE__ */ l(
      "div",
      {
        id: "axisEle",
        ref: n,
        children: /* @__PURE__ */ l(
          e,
          {
            width: r ? `${r}px` : p || "100%",
            height: i ? `${i}px` : i === 0 ? "auto" : "350px",
            options: W,
            series: c,
            type: "bar"
          },
          `${d}_${c.length}`
        )
      }
    )
  ] });
};
export {
  V as ColumnChart
};
